export const iconFontAwesomeMathematicsCircleMinus = (
	<i className="fa-solid fa-circle-minus"></i>
);
